<fs-dialog>
  <h1 mat-dialog-title>Manage {{title}}</h1>
  <mat-dialog-content>
    <app-attribute-list [projectId]="projectId" [class]="class" #attributeList></app-attribute-list>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button color="primary" mat-button (click)="close()">Done</button>
  </mat-dialog-actions>
</fs-dialog>
